// extracted by mini-css-extract-plugin
export default {"container":"Head_container__IyWq9","left":"Head_left__+aQoi","picture":"Head_picture__LyG2q","details":"Head_details__eBGXt","table":"Head_table__nXVTn"};